import React from 'react'
import { useTheme } from '@mui/material/styles'
import { LayoutWrapper, SelectedCloudIcon } from '@labrav/common'
import { MarketplaceTemplateForm } from './MarketplaceTemplateForm/MarketplaceTemplateForm'

export const MarketplaceTemplateFormWrapper: React.FC = () => {
  const theme = useTheme()

  return (
    <LayoutWrapper
      title={<div style={{ marginLeft: '8px' }}>Fields mapping manager</div>}
      component={MarketplaceTemplateForm}
      paddingZero
      actions={SelectedCloudIcon}
      isExternal={true}
      isSidePanelOpened={false}
      isBack={false}
      bgColor={theme.palette.text.white}
    />
  )
}

export default MarketplaceTemplateFormWrapper
